import { render, staticRenderFns } from "./SubscriptionSettings.vue?vue&type=template&id=7edcfe8d"
import script from "./SubscriptionSettings.vue?vue&type=script&lang=js"
export * from "./SubscriptionSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_webpack@5.99.8__handlebars@4.7.7_lodash@4.17.21_webpack@5.99.8/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports